// extracted by mini-css-extract-plugin
export default {"sectionTitleH3":"SectionTittleH3_sectionTitleH3__E2zGV"};